module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIAAAACABAMAAAAxEHz4AAAAG1BMVEUAAADvuVDuuVHuuFDzvlP/1VXvuVHuuFD////6na9CAAAAB3RSTlMAkvPVKwa9zEb/gAAAAMRJREFUaN7t2SsSwkAQhGEQ+AhSHAARj0GjsOEU6Dwqc4UcG7YgMyuTFpmtmv7Nqv1MtmL6wJj1uMnK5m/pvJ7z+y+RbUCqtvunNwJMrQJHQQCpFHhiwKjABQM6Be4YMCjQYECvwLbLFoGYwIIQiA34v0QCJQD+L5FACYD/SyRQApCKDsz/YgO/Mzbg/xUIECgB8P8rEyBAgAABAgT2AhqB6rOJBGrIRhqoLpuJoMZsqIKqoKnMmlporLNqYC600lzImPYBPP5rdLd5QP4AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/comm/images/document-conversion/onlinePreview/zip.png
// module id = 6T+P
// module chunks = 2